import toast from 'react-hot-toast';
import useApi from '../useApi';
import { ICancelAppointmentRes } from './index.type';

const useDeleteCampaignImage = ({ imageId }: { imageId?: string }) => {
  const { loading: deleteImageLoading, makeApiCall } = useApi({
    url: `/advertise/ads/${imageId}`,
    method: 'DELETE',
  });

  const deleteImage = async () => {
    const { response, error } = await makeApiCall<undefined, ICancelAppointmentRes>();
    if (response?.status) {
      toast.success(response.message);
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to delete campaign image. Please try again.');
      return { status: false };
    }
  };

  return {
    deleteImageLoading,
    deleteImage,
  };
};

export default useDeleteCampaignImage;
